import React, { Component } from 'react';
import { Box, Button, Card, Grid, IconButton, Typography } from '@material-ui/core';
import InputText from '../../../../commonModules/interface/form-input-inline';
import CardPage from '../../../../commonModules/layouts/CardPage';
import { GroupRadio, SingleRadio } from '../../../../commonModules/MUI/RadioAndCheckbox';
import { toast } from 'react-toastify';
import axios from 'axios';
import { AddCircleOutlineRounded, ArrowBackRounded, ArrowDownwardRounded, ArrowForwardRounded, ArrowUpwardRounded, CenterFocusWeakRounded, RemoveCircleOutline } from '@material-ui/icons';
import PopUp from '../../../../commonModules/interface/PopUp';
import BlockInventoryDetails from './BlockInventoryDetails';
import GenerateQrCode from '../products/GenerateQrCode';

const scale = 50; // 1 mètre = 50 pixels dans l'aperçu
const ZONES = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));
const pastelColors = [
    "#90C2E7", "#B7D1A3", "#F0C987", "#FFDDC1", "#94D0CC", 
    "#B4A8BD", "#D3B99F", "#E7C4C7", "#9BBE7E", "#F4B5BD",
    "#F5E1A4", "#9CC6E7", "#D6D7A1", "#E0AFA0", "#E8CABA", 
    "#A4C8A2", "#A1B0D4", "#C6CC9E", "#F8C6B7", "#B6D4E0", 
    "#E5D6A7", "#F1C6CF", "#8DB9CA", "#E4C7D2",  "#B39EB5", "#F9CB9C"
];

class PreviewLocForm extends Component {
    state = { 
        openZonePopup: false,
        showZone: {},
        showBlockInventory: "",
        openSectionPopup: false
    }
    
    makeZones = () => {
        const { local_longueur, local_largeur, local_nb_zones, local_orientation, zones } = this.props;
        console.log('==============MAKE ALLEYS======================');
       
        let alleys = []
        let width = 0
        let height = 0
          
        if (local_orientation === "v") {
            let widthCalc = (local_longueur / local_nb_zones * scale)
            width = `${widthCalc}px`
            height = "100%"
        } else {
            let heightCalc = (local_largeur / local_nb_zones * scale)
            height = `${heightCalc}px`
            width = "100%"
        }
            console.log('====================================');
            console.log({height, width});
            console.log('====================================');
        for (let index = 0; index < local_nb_zones; index++) {
            alleys.push(
                <>
                <Box 
                    // p={2}
                    style={{
                        width, 
                        height, 
                        textAlign:"center", 
                        backgroundColor: pastelColors[index],
                        // display: (local_orientation === "h" && "flex"),
                        border:"15px solid #dbd1ee"
                        // textOrientation: "sideways", 
                        // writingMode:"vertical-rl",
                        // alignItems: "center",
                        // justifyContent: "center"
                    }}
                    // onClick={() => this.customZone(index)}
                    id={`zone${ZONES[index]}`}
                    onClick={() => this.showZone(ZONES[index], index, `Z${ZONES[index]}–Se${index + 1}`, pastelColors[index])}
                >
                    {zones[index].nb_sections > 0 ?
                        <Box
                            style={{
                                width:"100%",
                                height:"100%",
                                display: (local_orientation === "h" && "flex"),
                            }}
                            
                        >
                            {/* <b>ZONE {ZONES[index]}</b> */}
                            {this.makeSections(index, ZONES[index], pastelColors[index])}
                            {/* <Button
                                startIcon={<AddCircleOutlineRounded />}
                                onClick={() => this.props.addSection(index)}
                            >
                                Section
                            </Button> */}
                        </Box>
                     :
                        <b>ZONE {ZONES[index]}</b>
                    }
                    {/* <Box style={{border: `1px dashed ${pastelColors[index]}`}}> */}
                        {/* <Button
                            startIcon={<AddCircleOutlineRounded />}
                            onClick={() => this.props.addSection(index)}
                            variant="contained"
                            color="primary"
                        >
                            Section
                        </Button> */}
                    {/* </Box> */}
                </Box>
                </>
            )
            
        }

        return alleys
    }
    
    makeSections = (zoneIndex, zone, color) => {
        const { local_orientation, zones } = this.props;
        console.log('==============MAKE SECTIONS======================');

        // const container = document.getElementById(`zone${zone}`);
        // // Récupérez la hauteur en pixels sans les marges
        // const heightInPixels = container.clientHeight;
        // const widthInPixels = container.clientWidth;


        let currentZone = zones[zoneIndex]
        let sections = []
        let sWidth = 0
        let sHeight = 0
        
        if (local_orientation === "v") {
            sWidth = '100%'
            sHeight = `${(100 / currentZone.nb_sections)}%`
            // sHeight = `${(heightInPixels / currentZone.nb_sections)}px`
        } else {
            sWidth = `${(100 / currentZone.nb_sections)}%`
            sHeight = "100%"
            // sWidth = `${(widthInPixels / currentZone.nb_sections)}px`
        }
        console.log('====================================', currentZone.nb_sections);
        console.log('====================================', sHeight,sWidth );

        let sectionStyle = {
            width: sWidth, 
            height: sHeight, 
            textAlign:"center", 
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border:"4px solid #dbd1ee",
            borderRadius: "8px",
            cursor:"pointer"
        }
        for (let index = 0; index < currentZone.nb_sections; index++) {
        
            sections.push(
                <Box 
                    p={1}
                    style={sectionStyle}
                    onClick={() => this.showZone(zone, zoneIndex, `Z${zone}–Se${index + 1}`, color)}
                    
                >
                    <b>Z{zone}—Se{index + 1}</b>
                </Box>
            )
        }
            
        
        return sections
    }
    makeSectionsFront = (zoneIndex, zone, color) => {
        const { local_orientation, zones } = this.props;
        console.log('==============MAKE SECTIONS======================');

        let currentZone = zones[zoneIndex]
        let sections = []        
        let sWidth = `${(100 / currentZone.nb_sections)}%`
        let sHeight = "100%"
        
        let sectionStyle = {
            // width: sWidth, 
            height: sHeight, 
            textAlign:"center", 
            // display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border:"6px solid lightgray",
            // borderRadius: "8px",
            cursor:"pointer"
        }
        for (let index = 0; index < currentZone.nb_sections; index++) {
        
            sections.push(
                <Box 
                    // p={1}
                    style={{
                        width: sWidth, 
                        // height: sHeight, 
                        textAlign:"center", 
                        // display: "flex",
                        // alignItems: "center",
                        // justifyContent: "center",
                        // border:"1px solid lightgray",
                        // borderRadius: "8px",
                        // cursor:"pointer"
                    }}
                    // onClick={() => this.showZone(zone, index, `Z${zone}–Se${index + 1}`, color)}
                    
                >
                    <Box p={1} style={{border:"1px solid lightgray"}}>
                        <Box>
                            <Typography variant="h6">
                                <b>Section {index + 1}</b>
                                {/* <b>Section{index + 1} | </b> */}
                                {/* <span>Z{zone}—Se{index + 1}</span> */}
                            </Typography>

                        </Box>
                        <Box>
                            <Button
                                startIcon={<AddCircleOutlineRounded />}
                                onClick={() => this.props.addLevel(zoneIndex, index)}
                                variant="outlined"
                                color="secondary"
                            >
                                Niveau
                            </Button>
                        </Box>
                    </Box>
                    <Box 
                        // p={1}
                        style={sectionStyle}
                        // onClick={() => this.showZone(zone, index, `Z${zone}–Se${index + 1}`, color)}
                        
                    >
                        <Box style={{height: '100%'}}>
                            {this.makeLevels(zoneIndex, zone, index)}
                        </Box>
                    </Box>
                </Box>
            )
        }
            
        
        return sections
    }


    makeLevels = (zoneIndex, zone, sectionIndex) => {
        console.log('==============MAKE LEVELS======================');
        console.log('====================================');
        const { showZone } = this.state;
        const { local_nb_levels, zones } = this.props;

        let levels = []
        let currentSection = zones[zoneIndex].sections[sectionIndex]

        let sWidth = '100%'
        let sHeight = `${(100 / currentSection.nb_levels)}%`
      
        let sectionStyle = {
            // width: sWidth, 
            height: "100%", 
            textAlign:"center", 
            // border:"4px solid #dbd1ee",
            borderRadius: "8px",
            backgroundColor: showZone.color,

        }

        for (let index = 0; index < currentSection.nb_levels; index++) {
            levels.push(
                <Box 
                    p={1} 
                    style={{ 
                        border: "1px dashed gray", 
                        backgroundColor: showZone.color, 
                        width: sWidth, 
                        height: sHeight
                    }}
                    // onClick={() => this.showBlock(`${showZone.name}—N${index}`)}
                >
                    <Card
                        elevation={3} 
                        p={1}
                        style={sectionStyle}
                    >
                        <Typography variant="h6">Niveau {index}</Typography>
                        <br />
                        <b>Z{zone}—Se{sectionIndex + 1}—N{index}</b>
                        {/* <b>{showZone.name}—N{index}</b> */}
                    </Card>
                </Box>
            )
        }
            
        
        return levels.reverse()
    }

    showZone =  (zone, index, name, color) => {
        this.setState({ showZone: {zone, index, name, color}, openZonePopup: true})
        // this.setState({ showZone: {zone, index, style, name, color}, openZonePopup: true})
    }

    showBlock =  (name) => {
        this.setState({ showBlockInventory: name, openBlockInventory: true})
    }

    render() {
        const { openZonePopup, showZone, openBlockInventory, showBlockInventory, openSectionPopup} = this.state;
        const { local_longueur, local_largeur, local_name, local_orientation, local_hauteur, local_nb_zones, form} = this.props;

        // TODO Ajout custom avec mesures exact % et placement des zones 
        const borderWidth = 4
        return (
                <Box>
                    {this.state.openQR && showBlockInventory && !form &&
                        <GenerateQrCode 
                            // {...this.props} // notif from here
                            handleClose={() => this.setState({openQR: false })} 
                            qrID={`${this.props.id}-${showBlockInventory}`}
                            qrRef={showBlockInventory}
                            title={showBlockInventory}
                        />
                    }
                    {openZonePopup && 
                        <PopUp
                            title={openBlockInventory ? `Inventaire ${showBlockInventory}` : `Allée ${showZone.zone} | Vue Face` }
                            maxWidth="lg"
                            secondaryAction={ openBlockInventory && !form &&
                                <IconButton
                                    size="large"
                                    onClick={() => this.setState({openQR: true })}
                                    title="QR Code"
                                >
                                    <CenterFocusWeakRounded />
                                </IconButton>
                            }
                            close={ () => this.setState({ showZone: {}, openZonePopup: false, showBlockInventory: "", openBlockInventory: false, openQR: false})}
                            appbar
                        >

                            {!form && openBlockInventory ?
                                <BlockInventoryDetails
                                    name={showBlockInventory}
                                    localID={this.props.id}
                                    handleClose={ () => this.setState({ showBlockInventory: "", openBlockInventory: false, openQR: false})}
                                />
                            :
                            <>
                                <Box p={2} style={{textAlign: "center"}}>
                                    <Button
                                        startIcon={<AddCircleOutlineRounded />}
                                        onClick={() => this.props.addSection(showZone.index)}
                                        variant="contained"
                                        color="primary"
                                        style={{width: "50%",}}
                                    >
                                        Ajouter une Section
                                    </Button>
                                </Box>
                                <Box
                                    p={3} 
                                    style={{ display: 'flex', justifyContent: "center", minHeight: "500px"}}
                                >
                                    {this.makeSectionsFront(showZone.index, ZONES[showZone.index], pastelColors[showZone.index])}
                                </Box>
                            </>
                            }
                        </PopUp>
                    }
                    
                    {(local_largeur + local_longueur) > 0 &&
                        <Card title="Aperçu" >
                            {/* <Box p={1}>
                                <Typography gutterBottom variant="h5" component="h2">
                                    {local_name && `Local ${local_name}`}
                                </Typography>
                            </Box> */}
                            <Box p={2} style={{display: "flex"}}>
                                <Box p={1}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineRounded />}
                                        onClick={() => this.props.addZone()}
                                    >
                                        Ajouter une Allée
                                    </Button>
                                </Box>
                                {/* <Box p={1}>
                                    <GroupRadio name="local_orientation" label="Orientation" onChange={(e) =>this.changeOrientation(e)} color="primary">
                                     <GroupRadio label="Orientation" onChange={(e) =>this.props.changeOrientation(e)} color="primary"> 
                                        <SingleRadio value="v" checked={local_orientation === "v"}label="Verticale" />
                                        <SingleRadio value="h" checked={local_orientation === "h"}label="Horizontale" />
                                    </GroupRadio>

                                </Box> */}
                                {/* {parseInt(local_nb_zones) > 0 &&
                                    <Box p={1}>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<RemoveCircleOutline color="error"/>}
                                            onClick={() => this.props.removeZone()}
                                        >
                                            Retirer une Allée
                                        </Button>
                                    </Box>
                                } */}
                            </Box>
                            <Box style={{display:"flex", textAlign: 'center'}}>

                                <Box p={1} style={{textAlign: 'center', writingMode: "vertical-rl", display: 'flex', justifyContent:"space-around"}} >            
                                    <ArrowUpwardRounded/>{local_largeur} m <ArrowDownwardRounded />
                                </Box>
                                
                                <Box p={2} style={{overflow:"auto"}}>
                                    <Box p={1} style={{textAlign: 'center', display: 'flex', justifyContent:"space-around"}}>
                                        <ArrowBackRounded/> {local_longueur} m <ArrowForwardRounded />
                                    </Box>
                                    <Box 
                                        style={{ 
                                            width: `${local_longueur * scale + borderWidth*2}px`, 
                                            height: `${local_largeur * scale + borderWidth*2}px`, 
                                            border: `${borderWidth}px solid grey`, 
                                            display: (local_orientation === "v" ? "flex": "block") 
                                        }}
                                    >
                                        {this.makeZones()}
                                    </Box>
                                </Box>
                            </Box>

                        </Card>
                    }
                
                </Box>
        );
    }
}

export default PreviewLocForm;